import { useEffect } from "react";
import {
  Editor,
  EditorBoldItalicUnderlineGroup,
  EditorBulletList,
  EditorContent,
  editorGenerateHTML,
  EditorGesaGreen,
  EditorOrderedList,
  EditorToolbar,
  EditorToolbarSeparator,
  useEditor,
} from "@/shared/components/editor/editor";

type GfsOfferHtmlEditorProps = {
  value: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  showToolbar?: boolean;
  minHeightClassName?: string;
};

export function GfsOfferHtmlEditor({
  value,
  onChange,
  disabled,
  showToolbar = true,
  minHeightClassName = "min-h-36",
}: GfsOfferHtmlEditorProps) {
  const targetValue = value?.trim() ? value : "<p></p>";
  const editor = useEditor(
    {
      content: targetValue,
      editable: !disabled,
      disableOrderedListInputRules: true,
      editorProps: {
        attributes: {
          class: `bg-transaparent rounded-md border px-3 py-1 ${minHeightClassName}`,
        },
      },
      onUpdate: ({ editor: instance }) => {
        if (instance.isEditable && onChange) {
          onChange(editorGenerateHTML(instance, undefined, true));
        }
      },
    },
    [],
  );

  useEffect(() => {
    if (!editor) {
      return;
    }
    editor.setEditable(!disabled, false);
  }, [disabled, editor]);

  useEffect(() => {
    if (!editor) {
      return;
    }
    const current =
      editorGenerateHTML(editor, undefined, true).trim() || "<p></p>";
    if (current === targetValue) {
      return;
    }
    if (!disabled && editor.isFocused) {
      return;
    }
    editor.commands.setContent(targetValue, { emitUpdate: false });
  }, [disabled, editor, targetValue]);

  if (!editor) {
    return null;
  }

  return (
    <Editor editor={editor}>
      {showToolbar ? (
        <EditorToolbar>
          <EditorBoldItalicUnderlineGroup />
          <EditorToolbarSeparator />
          <EditorBulletList />
          <EditorOrderedList />
          <EditorToolbarSeparator />
          <EditorGesaGreen />
        </EditorToolbar>
      ) : null}
      <EditorContent />
    </Editor>
  );
}
